
export default {
  name: 'AccordionGroupComponent',
  props: {
    _type: {
      type: String,
      default: null
    },
    _id: {
      type: String,
      default: ''
    },
    singleOpen: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      triggerOpenClose: 0
    };
  },

  methods: {
    onClickChild(e) {
      if (this.singleOpen) {
        this.triggerOpenClose = e;
      } else {
        this.triggerOpenClose = 'e';
      }
    }
  }
};
